export const REPORT_CHART_COLORS = {
  temperature: '#0f62fe',
  humidity: '#24a148',
};

export function inferReportTimeRange(startDate, endDate) {
  if (!startDate || !endDate) return '24h';
  const ms = new Date(endDate).getTime() - new Date(startDate).getTime();
  if (!Number.isFinite(ms) || ms <= 0) return '24h';
  const hours = ms / (1000 * 60 * 60);
  if (hours <= 1) return '1h';
  if (hours <= 6) return '6h';
  if (hours <= 24) return '24h';
  if (hours <= 24 * 7) return '7d';
  return '30d';
}

export function formatReportDateTime(date) {
  return `${date.toLocaleDateString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' })} ${date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })}`;
}

export function buildReportChartSeries(readings, { tempUnit = 'celsius' } = {}) {
  const tempData = [];
  const humidityData = [];

  (readings || []).forEach((reading) => {
    const date = new Date(reading.recorded_at);
    if (Number.isNaN(date.getTime())) return;

    const dateTimeString = formatReportDateTime(date);

    if (reading.temperature !== null && reading.temperature !== undefined) {
      let temp = reading.temperature;
      if (tempUnit === 'fahrenheit') {
        temp = (temp * 9) / 5 + 32;
      }
      tempData.push({
        group: 'Temperature',
        date: date.toISOString(),
        dateTime: dateTimeString,
        value: temp,
      });
    }

    if (reading.humidity !== null && reading.humidity !== undefined && reading.humidity > 0) {
      humidityData.push({
        group: 'Humidity',
        date: date.toISOString(),
        dateTime: dateTimeString,
        value: reading.humidity,
      });
    }
  });

  return { tempData, humidityData };
}

export function exportReportChartCsv(data, dataType, filename = 'report-data') {
  if (!data || data.length === 0) return;

  const rows = data.map((point) => ({
    'Date & Time': point.dateTime || formatReportDateTime(new Date(point.date)),
    [dataType]: point.value != null ? Number(point.value).toFixed(2) : '',
  }));

  const headers = Object.keys(rows[0]);
  const csvRows = [
    headers.join(','),
    ...rows.map((row) =>
      headers
        .map((header) => {
          const value = row[header];
          if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
            return `"${value.replace(/"/g, '""')}"`;
          }
          return value;
        })
        .join(',')
    ),
  ];

  const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}-${dataType.toLowerCase()}.csv`;
  link.click();
  URL.revokeObjectURL(link.href);
}
